import * as Sentry from '@sentry/react';
import config from 'src/config';

export const initSentry = () => {
  if (!config.sentryDsn) return;

  Sentry.init({
    dsn: config.sentryDsn,
    sendDefaultPii: true,
  });
};
